export const BORDER_SPACING = `0.1875rem`;
export const BORDER_SPACING_DBL = '0.375rem';
